import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
    chargeUrl,
    coordinatorsUrl, departmentsUrl, formatsActiveUrl, formatsUrl, importanceUrl,
    locationsActiveUrl,
    locationsUrl,
    namesUrl,
    peopleUrl,
    projectsActiveUrl,
    projectsUrl, purposesUrl,
    recordGroupsUrl,
    reposUrl, rolesUrl, storageUrl, worktypesActiveUrl, worktypesUrl
} from '../api-url';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AdminListService {
respMsg;
  constructor(private http: HttpClient, private router: Router) { }
  getPeople() {
    return this.http.get<any[]>(peopleUrl);
  }
  // active projects Groups included
  getProjects() {
    return this.http.get<any[]>(projectsActiveUrl);
  }
  // all projects; no included models
  getAllProjects() {
    return this.http.get<any[]>(projectsUrl);
  }
  getGroups() {
    return this.http.get<any[]>(recordGroupsUrl);
  }
  getNames() {
    return this.http.get<any[]>(namesUrl);
  }
  getCoordinators() {
    return this.http.get<any[]>(coordinatorsUrl);
  }
  getRepos() {
    return this.http.get<any[]>(reposUrl);
  }
  getWorkLocations() {
    return this.http.get<any[]>(locationsUrl);
  }
  getActiveLocations() {
    return this.http.get<any[]>(locationsActiveUrl);
  }
  getDepartments() {
    return this.http.get<any[]>(departmentsUrl);
  }
  getChargeto() {
    return this.http.get<any[]>(chargeUrl);
  }
  getRoles() {
    return this.http.get<any[]>(rolesUrl);
  }
  getPurposes() {
    return this.http.get<any[]>(purposesUrl);
  }
  getImportance() {
    return this.http.get<any[]>(importanceUrl);
  }
  getStorage() {
    return this.http.get<any[]>(storageUrl);
  }
  getFormats() {
    return this.http.get<any[]>(formatsActiveUrl);
  }
  getAllFormats() {
    return this.http.get<any[]>(formatsUrl);
  }
  getActiveWorkTypes() {
    return this.http.get<any[]>(worktypesActiveUrl);
  }
  getWorkTypes() {
    return this.http.get<any[]>(worktypesUrl);
  }
  // LOCATIONS
  createLibLocation(
    locationName,
    tub,
    shortName,
    acronym,
    locationRepoStatus
  ) {
    const location = {
     locationName,
     tub,
     shortName,
     acronym,
     locationRepoStatus
    };
    console.log('LOCATION', location);
    this.http
      .post(`${locationsUrl}/`, location)
      .subscribe(response => {
        console.log('CreateLocation RESPONSE', response);
        this.respMsg = response;
        this.getWorkLocations();
        this.router.navigate(['/admin/tempr']);
      });
  }

  updateLibLocation(
    locationId,
    locationName,
    locationStatus,
    locationRepoStatus
  ) {
    const location = {
      locationId,
      locationName,
     locationStatus,
      locationRepoStatus
    };
    console.log('LOCATION', location);
    this.http
      .put(`${locationsUrl}/${locationId}`, location)
      .subscribe(response => {
        console.log('UPDATE LOCATION RESPONSE', response);
        this.respMsg = response;
        this.getWorkLocations();
        this.router.navigate(['/admin/tempr']);
      });
  }
  deleteLocation(locationId) {
    this.http.delete(`${locationsUrl}/${locationId}`)
      .subscribe((response) => {
        console.log('Del Location RESPONSE', response);
        this.respMsg = response;
        this.getWorkLocations();
        this.router.navigate(['/admin/tempr']);
      });
  }
// DEPARTMENTS
  createDepartment(
    locationId,
    departmentName,
    shortName,
    acronym
  ) {
    const department = {
     locationId,
     departmentName,
     shortName,
   acronym
    };
    console.log('DEPARTMENT', department);
    this.http
      .post(`${departmentsUrl}/`, department)
      .subscribe(response => {
        console.log('CREATED DEPT RESPONSE', response);
        this.respMsg = response;
        this.getDepartments();
        this.router.navigate(['/admin/tempr']);
      });
  }

  updateDepartment(
    departmentId,
    departmentName,
    locationStatus,
  ) {
    const department = {
      departmentId,
      departmentName,
      locationStatus,
    };
    console.log('DEPARTMENT UPDATE', department);
    this.http
      .put(`${departmentsUrl}/${departmentId}`, department)
      .subscribe(response => {
        console.log('UPDATED DEPT RESPONSE', response);
        this.respMsg = response;
        this.getDepartments();
        this.router.navigate(['/admin/tempr']);
      });
  }
  deleteDepartment(departmentId) {
    this.http.delete(`${departmentsUrl}/${departmentId}`)
      .subscribe((response) => {
        console.log('DEL DEPT RESPONSE', response);
        this.respMsg = response;
        this.getDepartments();
        this.router.navigate(['/admin/tempr']);
      });
  }
// Formats
  createFormat(format) {
    console.log('NEW FORMAT', format);
    this.http
      .post(`${formatsUrl}/`, format)
      .subscribe(response => {
        console.log('CREATED FORMAT RESPONSE', response);
        this.respMsg = response;
        this.getAllFormats();
        this.router.navigate(['/admin/tempr']);
      });
  }
  updateFormat(
    formatId,
    format
  ) {
    this.http
      .put(`${formatsUrl}/${formatId}`, format)
      .subscribe(response => {
        console.log('UPDATED FORMAT RESPONSE', response);
        this.respMsg = response;
        this.getAllFormats();
        this.router.navigate(['/admin/tempr']);
      });
  }
  deleteFormat(formatId) {
    this.http.delete(`${formatsUrl}/${formatId}`)
      .subscribe((response) => {
        console.log('DEL FORMAT RESPONSE', response);
        this.respMsg = response;
        this.getAllFormats();
        this.router.navigate(['/admin/tempr']);
      });
  }
  // Importance
  createImportance(
    importanceName
  ) {
    this.http
      .post(`${importanceUrl}/`,  {importanceName})
      .subscribe(response => {
        console.log('CREATED IMPORTANCE RESPONSE', response);
        this.respMsg = response;
        this.getImportance();
        this.router.navigate(['/admin/tempr']);
      });
  }
  updateImportance(
    importanceId,
    importanceName,
    importanceInactive,
  ) {
    const importance = {
      importanceId,
      importanceName,
      importanceInactive,
    };
    this.http
      .put(`${importanceUrl}/${importanceId}`, importance)
      .subscribe(response => {
        console.log('UPDATED IMPORTANCE RESPONSE', response);
        this.respMsg = response;
        this.getImportance();
        this.router.navigate(['/admin/tempr']);
      });
  }
  deleteImportance(importanceId) {
    this.http.delete(`${importanceUrl}/${importanceId}`)
      .subscribe((response) => {
        console.log('UPDATED IMPORTANCE RESPONSE', response);
        this.respMsg = response;
        this.getImportance();
        this.router.navigate(['/admin/tempr']);
      });
  }
  // Purposes
  createPurpose(
    purposeName
  ) {
    this.http
      .post(`${purposesUrl}/`,  {purposeName})
      .subscribe(response => {
        console.log('CREATED IMPORTANCE RESPONSE', response);
        this.respMsg = response;
        this.getPurposes();
        this.router.navigate(['/admin/tempr']);
      });
  }
  updatePurpose(
    purposeId,
    purposeName,
    purposeInactive,
  ) {
    const purpose = {
      purposeId,
      purposeName,
      purposeInactive,
    };
    this.http
      .put(`${purposesUrl}/${purposeId}`, purpose)
      .subscribe(response => {
        console.log('UPDATED PURPOSE RESPONSE', response);
        this.respMsg = response;
        this.getPurposes();
        this.router.navigate(['/admin/tempr']);
      });
  }
  deletePurpose(purposeId) {
    this.http.delete(`${purposesUrl}/${purposeId}`)
      .subscribe((response) => {
        console.log('UPDATED PURPOSE RESPONSE', response);
        this.respMsg = response;
        this.getPurposes();
        this.router.navigate(['/admin/tempr']);
      });
  }
  // Work Types
  createWorkType(
    workType
  ) {
    this.http
      .post(`${worktypesUrl}/`,  {workType})
      .subscribe(response => {
        console.log('CREATED IMPORTANCE RESPONSE', response);
        this.respMsg = response;
        this.getWorkTypes();
        this.router.navigate(['/admin/tempr']);
      });
  }
  updateWorkType(
    workTypeId,
    workType,
    workTypeInactive,
  ) {
    const wp = {
      workTypeId,
      workType,
      workTypeInactive,
    };
    this.http
      .put(`${worktypesUrl}/${workTypeId}`, wp)
      .subscribe(response => {
        console.log('UPDATED workType RESPONSE', response);
        this.respMsg = response;
        this.getWorkTypes();
        this.router.navigate(['/admin/tempr']);
      });
  }
  deleteWorkType(workTypeId) {
    this.http.delete(`${worktypesUrl}/${workTypeId}`)
      .subscribe((response) => {
        console.log('UPDATED WorkType RESPONSE', response);
        this.respMsg = response;
        this.getWorkTypes();
        this.router.navigate(['/admin/tempr']);
      });
  }
  // Projects
  createProject(
    projectName,
    projectDescription,
    startDate,
    endDate,
    projectInactive
  ) {
    const project = {
      projectName,
      projectDescription,
      startDate,
      endDate,
      projectInactive
    };
    this.http
      .post(`${projectsUrl}/`,  project)
      .subscribe(response => {
        console.log('CREATED PROJECT RESPONSE', response);
        this.respMsg = response;
        this.router.navigate(['/admin/tempr']);
      });
  }
  updateProject(
    projectId,
    projectName,
    projectDescription,
    startDate,
    endDate,
    projectInactive
  ) {
    const project = {
      projectId,
      projectName,
      projectDescription,
      startDate,
      endDate,
      projectInactive
    };
    this.http
      .put(`${projectsUrl}/${projectId}`, project)
      .subscribe(response => {
        console.log('UPDATED project RESPONSE', response);
        this.respMsg = response;
        this.router.navigate(['/admin/tempr']);
      });
  }
  deleteProject(projectId) {
    // this.http.delete(`${apiUrl}projects/${projectId}`)
    this.http.delete(`${projectsUrl}/${projectId}`)
      .subscribe((response) => {
        console.log('Deleted Project Response', response);
        this.respMsg = response;
        this.router.navigate(['/admin/tempr']);
      });
  }
  // PEOPLE
  deleteUser(personId) {
    this.http.delete(`${peopleUrl}/` + personId)
      .subscribe((response) => {
        console.log('Del User Response', response);
        this.respMsg = response;
        this.router.navigate(['/admin/tempr']);
      });
  }
  createUser(person) {
    this.http
      .post(`${peopleUrl}/`, person)
      .subscribe(response => {
        console.log('New User Response', response);
        this.respMsg = response;
        this.router.navigate(['/admin/tempr']);
      });
  }
  updatePerson(
    personId,
    data
  ) {
    this.http
      .put(`${peopleUrl}/${personId}`, data)
      .subscribe(response => {
        console.log('UPDATED person RESPONSE', response);
        this.respMsg = response;
        this.router.navigate(['/admin/people']);
      });
  }
}
